"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepClone = deepClone;
exports.default = void 0;
exports.forEach = forEach;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
/**
 * 自定义页面（拖拉装修）通用工具
 * 仅放真正被各处复用的轻量函数；不要在此堆积业务逻辑。
 */

/**
 * 深拷贝
 * 优先使用原生 structuredClone（支持的浏览器/Node >= 17），
 * 否则回退到 JSON 方案（足以覆盖装修配置这种纯数据结构）。
 */
function deepClone(obj) {
  if (obj == null || (0, _typeof2.default)(obj) !== 'object') return obj;
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(obj);
    } catch (e) {
      // 无法克隆的结构（如函数）会抛错，回退到 JSON
    }
  }
  return JSON.parse(JSON.stringify(obj));
}

/**
 * 对数组 / 对象做 forEach 遍历，统一调用 (value, key/index, source)
 * @param {Array|Object} obj
 * @param {(value: any, key: number|string, source: any) => void} cb
 */
function forEach(obj, cb) {
  if (obj == null || typeof cb !== 'function') return;
  if (Array.isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      cb(obj[i], i, obj);
    }
    return;
  }
  var keys = Object.keys(obj);
  for (var _i = 0, _l = keys.length; _i < _l; _i++) {
    var k = keys[_i];
    cb(obj[k], k, obj);
  }
}
var _default = exports.default = {
  deepClone: deepClone,
  forEach: forEach
};